module.exports = __webpack_public_path__ + "static/HUB2-885a05a42d7ea3f1b6ed3eea85009b7a.jpg";